import { MenuConfig, ToolbarConfig } from '@tencent/workbench';
import { ActionType } from '@editor/src/js/constants/common-action-type';
import i18n from '@i18next/i18n';
import { MenuDescriptionIcon } from '@framework/workbench/common/components/menu-description-icon';
import React from 'react';
import VIP_ICON from '@tencent/docs-design-resources/icon/mobile/svg/vip_minitag_12.svg';
import { wrapIdForVip } from '@src/framework/workbench/util/wrap-id-util';
import { MUTI_PICTURE_POS_SETTING_ICON } from '@src/framework/editor/src/img/pageIndex';

export const config = {
    id: ActionType.MUTI_PICTURE_POS_SETTING,
    content: i18n.t('批量图片布局'),
    icon: MUTI_PICTURE_POS_SETTING_ICON,
};

export const INSERT_TEXT_MENU_CONFIGS: MenuConfig[] = [
    {
        name: config.id,
        content: config.content,
        tooltip: config.content,
        description: <MenuDescriptionIcon iconSrc={VIP_ICON} />,
    },
];
export const TOOLBAR_ITEMS: ToolbarConfig[] = [
    {
        name: wrapIdForVip(config.id),
        tooltip: config.content,
        text: config.content,
        icon: <img src={config.icon} alt={''}/>,
        respectOffline: true,
    },
];
